export const SESSION_DATA_IDENTIFIER = 'session'

/**
 * Synchronously gets session data from localStorage.
 * Returns null if no data exists or if parsing fails.
 */
export const getSessionFromStorage = (): { token?: string } | null => {
  const data = localStorage.getItem(SESSION_DATA_IDENTIFIER)
  if (data) {
    try {
      return JSON.parse(data)
    } catch {
      return null
    }
  }
  return null
}

/**
 * Synchronously sets session data in localStorage.
 */
export const setSessionInStorage = (sessionData: { token: string }): void => {
  localStorage.setItem(SESSION_DATA_IDENTIFIER, JSON.stringify(sessionData))
}

/**
 * Removes session data from localStorage.
 * Used during logout and SSO re-auth flows.
 */
export const removeSessionData = (): void => {
  localStorage.removeItem(SESSION_DATA_IDENTIFIER)
}
